import { Auth } from "aws-amplify";
import { get, isEmpty } from "lodash";

import { getUserId, getUserRole } from "src/utils";
import LogRocket from 'logrocket';

const useLogRocketInitialization = (companyDetails) => {
  if(!isEmpty(Auth) && !isEmpty(companyDetails)) {
    LogRocket.identify(get(Auth, "user.attributes.email", ""), {
      name: `${get(
        Auth,
        "user.attributes.custom:firstName",
        ""
      )} ${get(Auth, "user.attributes.custom:lastName", "")}`,
      email: get(Auth, "user.attributes.email", ""),
      userRole: getUserRole(),
      accountId: get(companyDetails, "tenantId", ""),
      accountName: get(companyDetails, "name", "")
    });
    return true;
  }
};

export default useLogRocketInitialization;